import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M6.763 12.147a1.153 1.153 0 110-2.307 1.153 1.153 0 010 2.307zM3.652 15.145a1.153 1.153 0 110-2.306 1.153 1.153 0 010 2.306zM8.22 16.298a1.153 1.153 0 110-2.307 1.153 1.153 0 010 2.307zM15.453 11.113a4.438 4.438 0 012.768-.203c1.246-2.223 1.9-6.56 2.067-8.239a1.188 1.188 0 011.305-1.161 1.19 1.19 0 011.057 1.392c-.065.673-.61 5.932-2.344 9.088.477.399.847.909 1.08 1.485.343.95.372 1.985.083 2.953l-8.304-3.35a4.429 4.429 0 012.288-1.965zM6.945 18.596c.139 0 3.239.701 5.675-4.244l8.497 3.441c-.369 1.495-1.32 4.494-3.312 5.647a.47.47 0 01-.221.064h-.277a12.062 12.062 0 01-3.202-.47 8.83 8.83 0 002.584-2.768.696.696 0 10-1.21-.692 8.211 8.211 0 01-3.025 2.906 28.085 28.085 0 01-1.578-.646 9.015 9.015 0 002.934-2.684.727.727 0 00-1.236-.766 8.25 8.25 0 01-3.303 2.712 28.14 28.14 0 01-2.768-1.651.47.47 0 01-.157-.581.49.49 0 01.6-.268z",
      fill: "#2d6ded"
    }
  )
);
export {
  t as default
};
